import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL, getAuthConfig } from "./shared";

/*
 * Écran préleveur (cahier des charges labo, section 14). Port de
 * PreleveurModule (frontend/src/pages/HopitalDashboard.js) sur la route
 * dédiée /api/lab/reception/queue (backend/routes/lab/reception.py, PR3b) —
 * même file d'attente que ReceptionModule, vue différente taillée pour le
 * poste de prélèvement (un seul patient à la fois).
 */
export default function PreleveurModule({ can }) {
  const [queue, setQueue] = useState([]);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try { const r = await axios.get(`${API_URL}/api/lab/reception/queue`, getAuthConfig()); setQueue(r.data.queue || []); }
    catch (e) { setError("Impossible de charger la file d'attente"); }
  };
  useEffect(() => {
    load();
    const poll = setInterval(load, 5000);
    return () => clearInterval(poll);
  }, []);

  const current = queue.find((q) => q.status === "en_cours") || queue.find((q) => q.status === "appelee") || null;
  const nextWaiting = queue.find((q) => q.status === "attente") || null;
  const remaining = queue.filter((q) => q.status === "attente").length;

  const act = async (q, action) => {
    setBusy(true); setError("");
    try { await axios.put(`${API_URL}/api/lab/reception/queue/${q.queue_id}/${action}`, {}, getAuthConfig()); await load(); }
    catch (e) { setError("Erreur"); }
    finally { setBusy(false); }
  };

  const fmtHeure = (iso) => iso ? new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }) : "—";

  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: "#0F172A", margin: 0 }}>Écran préleveur</h1>
      {error && <div style={{ background: "#FCEBEB", border: "1px solid #F7C1C1", color: "#A32D2D", borderRadius: 8, padding: "10px 14px", marginTop: 14, fontSize: 13 }}>{error}</div>}

      <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
        <div style={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: 16, padding: 32, width: "100%", maxWidth: 460, textAlign: "center" }}>
          {current ? (
            <>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#64748B", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Patient actuel</div>
              <div style={{ fontSize: 26, fontWeight: 700, color: "#0F172A" }}>{current.patient_name || "—"}</div>
              <div style={{ fontSize: 14, color: "#475569", marginTop: 10 }}>
                {current.act_type ? current.act_type : "Acte non précisé"}
                {current.called_at && ` · Appelé à ${fmtHeure(current.called_at)}`}
              </div>
              <div style={{ display: "flex", justifyContent: "center", gap: 16, marginTop: 18, fontSize: 13 }}>
                <span style={{ color: current.checklist?.identite ? "#166534" : "#A32D2D" }}>{current.checklist?.identite ? "✓" : "⚠"} Identité</span>
                <span style={{ color: current.checklist?.infos ? "#166534" : "#A32D2D" }}>{current.checklist?.infos ? "✓" : "⚠"} Informations</span>
              </div>
              <div style={{ marginTop: 26 }}>
                {current.status === "appelee" && can("reception:manage") && (
                  <button disabled={busy} onClick={() => act(current, "start")} style={{ width: "100%", padding: "16px", background: "#3730A3", color: "#fff", border: "none", borderRadius: 12, fontSize: 17, fontWeight: 700, cursor: "pointer" }}>
                    Commencer prise en charge
                  </button>
                )}
                {current.status === "en_cours" && can("reception:manage") && (
                  <button disabled={busy} onClick={() => act(current, "done")} style={{ width: "100%", padding: "16px", background: "#166534", color: "#fff", border: "none", borderRadius: 12, fontSize: 17, fontWeight: 700, cursor: "pointer" }}>
                    Terminer prise en charge
                  </button>
                )}
              </div>
            </>
          ) : nextWaiting ? (
            <>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#64748B", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 8 }}>Patient suivant</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: "#0F172A" }}>{nextWaiting.patient_name || "—"}</div>
              <div style={{ fontSize: 13, color: "#94A3B8", marginTop: 4 }}>Arrivé à {fmtHeure(nextWaiting.arrived_at)}</div>
              {can("reception:manage") && (
                <button disabled={busy} onClick={() => act(nextWaiting, "call")} style={{ width: "100%", marginTop: 22, padding: "16px", background: "#185FA5", color: "#fff", border: "none", borderRadius: 12, fontSize: 17, fontWeight: 700, cursor: "pointer" }}>
                  Appeler
                </button>
              )}
            </>
          ) : (
            <div style={{ padding: "24px 0", color: "#94A3B8", fontSize: 15 }}>Aucun patient en attente de prélèvement.</div>
          )}
        </div>
      </div>
      {remaining > 0 && (
        <div style={{ textAlign: "center", marginTop: 16, fontSize: 13, color: "#64748B" }}>{remaining} patient(s) encore en attente</div>
      )}
    </div>
  );
}
